module.exports = __webpack_public_path__ + "img/autohero-logo.6d45821c.svg";